import { GlueRequestInitExtension, HttpClientPlugin, InternalRequestInit } from '../types';

export function createWithGlueResourcePlugin(): HttpClientPlugin<InternalRequestInit & GlueRequestInitExtension> {
  return {
    async beforeRequest(url, options) {
      if (!options.glue?.type || !options.json) {
        return { url, options };
      }

      options.json = {
        data: {
          type: options.glue.type,
          attributes: options.json,
        },
      };

      return { url, options };
    },
  };
}
